export const LogoWorkShort: {
  name: 'logo_work_short-8c33bcb7ebaf'
} = {
  name: 'logo_work_short-8c33bcb7ebaf'
}
